import { gql } from '@apollo/client';

export const GET_ALL_DROPDOWNS = gql`
  query getAllDropdowns($first: Int!, $offset: Int!, $filter: DropdownFilter!) {
    allDropdowns(filter: $filter, offset: $offset, first: $first) {
      nodes {
        ddId
        ddLabel
        ddValue
        ddType
      }
    }
  }
`;

export type DropdownNode = {
  ddId: string;
  ddLabel: string;
  ddValue: string;
  ddType: 'GENRE' | 'AGE_RATING' | 'IMAGE_TYPE';
};

export type GetAllDropdownsData = {
  allDropdowns: {
    nodes: DropdownNode[];
  };
};

export type DropdownFilter = {
  ddType?: {
    equalTo?: string;
  };
  ddValue?: {
    in?: string[];
    notIn?: string[];
  };
  ddDeletedAt?: {
    isNull?: boolean;
  };
};

export type GetAllDropdownsVariables = {
  first: number;
  offset: number;
  filter: DropdownFilter;
};

export interface CategoryInfo {
  ddId?: string;
  ddLabel?: string;
  ddValue?: string;
  ddType?: string;
}

export interface ChannelInfo {
  chId: string;
  chName: string;
  chHandle: string;
  chAvatarUrl: string;
  chBannerUrl: string;
  isFollowedByMe: boolean;
  followersCount: number;
}

export interface PlaylistLinkInfo {
  first?: string;
  last?: string;
  next?: string;
}

export interface PlaylistInfo {
  description?: string;
  feed_instance_id?: string;
  feedid?: string;
  kind?: string;
  title?: string;
  contentType?: string;
  shelfImageAspectRatio?: string;
  cardImageAspectRatio?: string;
  imageLabel?: string;
  links?: PlaylistLinkInfo;
  playlist?: string;
  show_title?: string;
  railType?: string;
}

export interface VideoItem {
  ma_id: string;
  creatorId?: string;
  creatorName?: string;
  creatorAvatarUrl?: string;
  likeCount?: number;
  isLikedByUser?: boolean;
  JwMediaInfo?: any; // Ungal structure-kku erpa specific interface maathikollalam
  categoryInfo?: CategoryInfo[];
  channelInfo?: ChannelInfo;
}

export interface GetVideosByPlaylistIdInput {
  playlistId: string;
  first?: number;
  offset?: number;
}

export interface GetVideosByPlaylistIdVariables {
  input: GetVideosByPlaylistIdInput;
}

export interface GetVideosByPlaylistIdData {
  getVideosByPlaylistId: {
    playelistInfo: PlaylistInfo;
    videos: VideoItem[];
    totalCount: number;
  };
}


export const GET_VIDEOS_BY_PLAYLIST_ID = gql`
  query GetVideosByPlaylistId($input: GetVideosByPlaylistIdInput!) {
    getVideosByPlaylistId(input: $input) {
      playelistInfo {
        description
        feed_instance_id
        feedid
        kind
        title
        contentType
        shelfImageAspectRatio
        cardImageAspectRatio
        imageLabel
        links {
          first
          last
          next
        }
        playlist
        show_title
        railType
      }
      videos {
        ma_id
        creatorId
        creatorName
        creatorAvatarUrl
        likeCount
        isLikedByUser
        JwMediaInfo
        categoryInfo {
          ddId
          ddLabel
          ddValue
          ddType
        }
        channelInfo {
          chId
          chName
          chHandle
          chAvatarUrl
          chBannerUrl
        }
      }
      totalCount
    }
  }
`;
